/** The statistics readout. Rebuilt only when the modal is opened. */

import type { GameState } from '../../sim/state.ts';
import { byId } from '../dom.ts';
import { formatDuration, formatInt, formatNumber } from '../format.ts';

export interface StatsPanel {
  update(state: GameState): void;
}

export function createStatsPanel(): StatsPanel {
  const list = byId('stat-list');

  function update(state: GameState): void {
    const f = state.settings.numberFormat;
    const s = state.stats;

    const rows: Array<[string, string]> = [
      ['Lifetime sparks', formatNumber(s.lifetimeThoughts, f)],
      ['This run', formatNumber(state.thoughtsThisRun, f)],
      ['Best run', formatNumber(s.bestRunThoughts, f)],
      ['Ideas forced', formatInt(s.meltdowns)],
      ['Hottest survived', `${s.hottestSurvived.toFixed(1)}°`],
      [
        'Fastest meltdown',
        s.fastestMeltdownSec > 0 ? formatDuration(s.fastestMeltdownSec) : '—',
      ],
      ['Current run time', formatDuration(state.runTimeSec)],
      ['Total playtime', formatDuration(s.totalPlaytimeSec)],
      ['Ideas banked', formatNumber(state.greyMatter, f)],
      ['Memories formed', formatInt(Object.keys(state.skills).length)],
      ['First powered on', new Date(s.firstPlayedAt).toLocaleDateString()],
    ];

    list.replaceChildren();
    for (const [label, value] of rows) {
      const dt = document.createElement('dt');
      dt.textContent = label;
      const dd = document.createElement('dd');
      dd.textContent = value;
      list.append(dt, dd);
    }
  }

  return { update };
}
